// removed by extract-text-webpack-plugin
module.exports = {"base":"Stat_base--2p5kD","icon":"Stat_icon--2k5Jy","icon__battles":"Stat_icon__battles--2BUn3","iconBattles":"Stat_icon__battles--2BUn3","icon__level":"Stat_icon__level--141hy","iconLevel":"Stat_icon__level--141hy","icon__players":"Stat_icon__players--jzanx","iconPlayers":"Stat_icon__players--jzanx","icon__victories":"Stat_icon__victories--8QOp7","iconVictories":"Stat_icon__victories--8QOp7","value":"Stat_value--wC4Hn","title":"Stat_title--28uwM"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Stat/Stat.scss
// module id = 2260
// module chunks = 11